// Pin Code Checker functionality for Shopify

// Immediately run to intercept events as early as possible
(function () {
  'use strict';

  // Global flag to track if PIN validation is pending
  window.pinValidationPending = false;
  // Global flag to track if we are replaying a validated event
  window.pincodeEventReplaying = false;

  // Early loading functionality: Preload serviceable PINs when page loads
  window.preloadedServiceablePins = null;
  window.preloadedServiceablePinsTimestamp = null;

  // Function to pre-load serviceable PINs early
  async function preloadServiceablePins() {
    try {
      // Check if we have cached pins that are still valid (less than 24 hours old)
      const cachedPins = localStorage.getItem('shopify_serviceable_pins_cache');
      const cachedTimestamp = localStorage.getItem('shopify_serviceable_pins_timestamp');

      if (cachedPins && cachedTimestamp) {
        const now = Date.now();
        const cacheAge = now - parseInt(cachedTimestamp);

        // If cache is less than 24 hours old, use it
        if (cacheAge < 24 * 60 * 60 * 1000) {
          window.preloadedServiceablePins = JSON.parse(cachedPins);
          window.preloadedServiceablePinsTimestamp = parseInt(cachedTimestamp);

          return window.preloadedServiceablePins;
        }
      }

      // If no valid cache, load from CSV

      const pins = await loadServiceablePins();

      if (pins && pins.length > 0) {
        // Cache the pins in localStorage with timestamp
        localStorage.setItem('shopify_serviceable_pins_cache', JSON.stringify(pins));
        localStorage.setItem('shopify_serviceable_pins_timestamp', Date.now().toString());

        window.preloadedServiceablePins = pins;
        window.preloadedServiceablePinsTimestamp = Date.now();

      }

      return pins;
    } catch (error) {

      return [];
    }
  }

  // Start preloading early in the page lifecycle
  if (window.pincodeFileUrl && window.pincodeFileUrl.trim() !== '') {
    // Use setTimeout to allow other scripts to initialize first
    setTimeout(preloadServiceablePins, 0);
  }

  // Add console log to verify the URL is working


  // Check if window.pincodeFileUrl is available (from Liquid template)
  if (!window.pincodeFileUrl) {


    // Try to find if we're on a product page and check for product metafield as a fallback
    if (typeof product !== 'undefined' && product && product.metafields && product.metafields.custom && product.metafields.custom.pincode_csv) {
      window.pincodeFileUrl = product.metafields.custom.pincode_csv.value.url;
    }
    // Try to find if we're on a collection page and check for collection metafield as a fallback
    else if (typeof collection !== 'undefined' && collection && collection.metafields && collection.metafields.custom && collection.metafields.custom.pincode_csv) {
      window.pincodeFileUrl = collection.metafields.custom.pincode_csv.value.url;
    }

    if (window.pincodeFileUrl && !window.pincodeFileUrl.startsWith('http')) {
      window.pincodeFileUrl = 'https:' + window.pincodeFileUrl;
    }
  }

  // Ensure we only initialize once to avoid conflicts
  if (window.PinCodeCheckerInitialized) {
    return;
  }

  window.PinCodeCheckerInitialized = true;

  // Global intercept for cart add requests
  // Monitor and intercept any cart-related network requests when validation is pending
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];

    // If PIN validation is pending and this is a cart add request, block it
    if (window.pinValidationPending && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {

      // Return a resolved Promise with a mock response to prevent errors
      return Promise.resolve({
        ok: false,
        status: 400,
        json: () => Promise.resolve({ error: 'Cart operation blocked due to PIN validation' }),
        text: () => Promise.resolve('Cart operation blocked due to PIN validation')
      });
    }



    // Otherwise, proceed with the original fetch
    return originalFetch.apply(this, args);
  };

  // Also monitor XMLHttpRequest: while PIN validation is pending, cart requests (/cart/add and any other
  // /cart call) are not sent. Patched on the browser's own XMLHttpRequest.prototype, as other scripts do,
  // rather than by replacing window.XMLHttpRequest: the replacement constructor returned plain browser
  // requests, so scripts that hook the prototype (Magic Wishlist's cart sync) either missed every request
  // or threw "Cannot assign to read only property 'send'" (2026-10-21). Patches chain, whoever loads first.
  const xhrProto = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
  if (xhrProto && !xhrProto.__pinCheckerWrapped) {
    xhrProto.__pinCheckerWrapped = true;
    const originalOpen = xhrProto.open;
    const originalSend = xhrProto.send;
    xhrProto.open = function (method, url) {
      // Store the URL for later checking
      this._pinUrl = url;
      return originalOpen.apply(this, arguments);
    };
    xhrProto.send = function () {
      if (window.pinValidationPending && typeof this._pinUrl === 'string' && this._pinUrl.includes('/cart')) {
        // Don't send the request
        return;
      }
      return originalSend.apply(this, arguments);
    };
  }

  // Check if user is logged in
  const isLoggedIn = checkIfLoggedIn();

  // Get saved PIN from localStorage if available
  const savedPin = getSavedPin();

  // Attach event listeners to add-to-cart buttons regardless of login status
  // The login check will happen at the time of clicking
  attachAddToCartListeners();

  // Also observe for dynamically added cart buttons
  observeDynamicCartButtons();

  // Run site-wide pincode validation on page load
  // This will disable buttons for non-serviceable products
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(() => {
        validateAllProductsOnPage();
        updateHeaderPincode();
        initHeaderPincodePill();
      }, 500);
    });
  } else {
    setTimeout(() => {
      validateAllProductsOnPage();
      updateHeaderPincode();
      initHeaderPincodePill();
    }, 500);
  }
})();

// Function to update the Pincode display in the header
function updateHeaderPincode() {
  const pincode = checkIfLoggedIn() ? getUserZipCode() : getSavedPin();
  const headerPincodeText = document.getElementById('headerPincodeText');
  const headerPincodeTextMobile = document.getElementById('headerPincodeTextMobile');

  if (headerPincodeText) {
    if (pincode) {
      headerPincodeText.textContent = `Delivering to ${pincode}`;
    } else {
      headerPincodeText.textContent = 'Enter your Pincode';
    }
  }

  if (headerPincodeTextMobile) {
    if (pincode) {
      headerPincodeTextMobile.textContent = `Delivering to ${pincode}`;
    } else {
      headerPincodeTextMobile.textContent = 'Enter your Pincode';
    }
  }

  // Also update any other indicators
  const otherIndicators = document.querySelectorAll('.header-pincode-indicator, .pincode-badge-text');
  otherIndicators.forEach(indicator => {
    if (pincode) {
      indicator.textContent = `Delivering to ${pincode}`;
    } else {
      indicator.textContent = 'Enter Pincode';
    }
  });
}

// Function to initialize the header Pincode pill click listener
function initHeaderPincodePill() {
  const pill = document.getElementById('headerPincodePill');
  const pillMobile = document.getElementById('headerPincodePillMobile');

  if (pill) {
    pill.addEventListener('click', function () {
      showPinPopup(null, window.pincodeFileUrl);
    });
  }

  if (pillMobile) {
    pillMobile.addEventListener('click', function () {
      showPinPopup(null, window.pincodeFileUrl);
    });
  }
}

// Override the addToCartFunction if it exists to integrate with PIN validation
if (typeof window.addToCartFunction !== 'undefined') {
  const originalAddToCartFunction = window.addToCartFunction;
  window.addToCartFunction = function () {
    // Get the closest form to this button
    var button = event.target || this;
    var form = button.closest('.product-single__form');

    // Get the product-specific CSV URL if available
    const productContainer = button.closest('[data-pincode-csv-url]');
    const productCsvUrl = productContainer ? productContainer.getAttribute('data-pincode-csv-url') : window.pincodeFileUrl;

    // Check if we need PIN validation for this product
    if (!productCsvUrl || productCsvUrl.trim() === '') {

      // Call the original function if no validation needed
      return originalAddToCartFunction.call(this);
    }

    // Check if PIN validation is already pending
    if (window.pinValidationPending) {

      return;
    }

    // Get the form element
    var form = button.closest('.product-single__form');
    if (form) {
      // Create a mock event to pass to handleAddToCartEvent
      var mockEvent = {
        preventDefault: function () { },
        stopPropagation: function () { },
        stopImmediatePropagation: function () { },
        target: button
      };

      // Prevent the form from submitting and handle validation
      handleAddToCartEvent(mockEvent, form);

      // Don't proceed with the original function if validation is needed
      return false;
    }

    // If no form found, call the original function
    return originalAddToCartFunction.call(this);
  };
}

// Also wrap the addToCartFunction in the product form to make sure it's intercepted
// This handles the onclick="addToCartFunction()" calls in the template
document.addEventListener('click', function (e) {
  // Check if the clicked element or its parent has the addToCartFunction call
  const elementWithOnClick = e.target.closest('[onclick]');
  if (elementWithOnClick) {
    const onclickValue = elementWithOnClick.getAttribute('onclick');
    if (onclickValue && onclickValue.includes('addToCartFunction()')) {
      // Get the product-specific CSV URL if available
      const productContainer = elementWithOnClick.closest('[data-pincode-csv-url]');
      const productCsvUrl = productContainer ? productContainer.getAttribute('data-pincode-csv-url') : window.pincodeFileUrl;

      // Prevent the default action if we need PIN validation
      if (productCsvUrl && productCsvUrl.trim() !== '') {
        // If we are replaying, let it pass
        if (window.pincodeEventReplaying) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Check if PIN validation is already pending
        if (window.pinValidationPending) {

          return false;
        }

        // Handle the add to cart event with PIN validation
        handleAddToCartEvent(e, elementWithOnClick);
        return false;
      }
    }
  }
}, true); // Use capture phase to intercept before other handlers

// Function to load serviceable PIN codes
async function loadServiceablePins() {
  // Check if we have preloaded pins available (early loaded)
  if (window.preloadedServiceablePins && window.preloadedServiceablePins.length > 0) {

    return window.preloadedServiceablePins;
  }

  // Check if we have cached pins that are still valid (less than 24 hours old)
  const cachedPins = localStorage.getItem('shopify_serviceable_pins_cache');
  const cachedTimestamp = localStorage.getItem('shopify_serviceable_pins_timestamp');

  if (cachedPins && cachedTimestamp) {
    const now = Date.now();
    const cacheAge = now - parseInt(cachedTimestamp);

    // If cache is less than 24 hours old, use it
    if (cacheAge < 24 * 60 * 60 * 1000) {
      const parsedPins = JSON.parse(cachedPins);

      return parsedPins;
    }
  }

  // Strict URL Sanitization: Use this logic to build the URL so it never doubles the domain
  let rawUrl = window.pincodeFileUrl;

  if (!rawUrl || rawUrl.trim() === '') {
    // Automatic Bypass (The "Hide" Rule): hide the pincode-checker-wrapper element
    const wrapper = document.getElementById('pincode-checker-wrapper');
    if (wrapper) {
      wrapper.style.display = 'none';
    }
    return [];
  }

  // Remove domain if it exists, then add it back cleanly
  let path = rawUrl.replace(/^https?:\/\/[^\/]+/, '');

  // Define possible URL formats to try
  const urlFormats = [
    // Original sanitized path
    'https://cdn.shopify.com' + path,
    // Format with /s/files/1/store-id/...
    `https://cdn.shopify.com/s/files/1/0662/0594/1980/files/${path.split('/').pop().split('?')[0]}`,
    // Alternative format without /files/ in the middle
    `https://cdn.shopify.com/s/files/1/0662/0594/1980/${path.split('/').pop().split('?')[0]}`,
    // Direct URL without modification (in case the original is correct)
    rawUrl
  ];

  let response;
  let csvText;
  let foundWorkingUrl = false;

  // Try each URL format until one works
  for (const url of urlFormats) {


    try {
      response = await fetch(url);

      if (response.ok) {

        csvText = await response.text();
        foundWorkingUrl = true;
        break;
      } else {

      }
    } catch (error) {

      continue; // Try the next URL
    }
  }

  // If no URL worked, hide the wrapper and return empty array
  if (!foundWorkingUrl) {

    const wrapper = document.getElementById('pincode-checker-wrapper');
    if (wrapper) {
      wrapper.style.display = 'none';
    }
    return [];
  }

  const lines = csvText.split(/\r?\n/);

  // Parsing Safety: continue skipping the 'Pincode' header row and trimming spaces from the numbers
  const pins = lines.slice(1) // Skip header
    .map(line => line.split(',')[0].replace(/["']/g, "").trim()) // Extract first column, clean
    .filter(pin => pin && pin.length >= 6); // Filter for valid PINs

  // Cache the pins in localStorage with timestamp for future fast access
  if (pins && pins.length > 0) {
    localStorage.setItem('shopify_serviceable_pins_cache', JSON.stringify(pins));
    localStorage.setItem('shopify_serviceable_pins_timestamp', Date.now().toString());
  }


  return pins;
}

// Function to check if user is logged in
function checkIfLoggedIn() {
  // Check for customer login status in Shopify
  // First try the standard Shopify customer object
  if (typeof Shopify !== 'undefined' && Shopify.hasOwnProperty('customer') && Shopify.customer && Shopify.customer.id) {
    return true;
  }

  // Check for customer data in window object
  if (window.Shopify && window.Shopify.customerData && window.Shopify.customerData.customer_id) {
    return true;
  }

  // Check for customer object directly (including simulated ones)
  if (typeof window.customer !== 'undefined' && window.customer && window.customer.id) {
    return true;
  }

  // Also check for global customer object
  if (typeof customer !== 'undefined' && customer && customer.id) {
    return true;
  }

  // Check for customer ID in analytics
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
    return true;
  }

  return false;
}

// Async function to fetch customer data from Shopify API
async function fetchCustomerData() {
  if (!checkIfLoggedIn()) {
    return null;
  }

  try {
    // Try to get customer ID from various sources
    let customerId = null;

    if (typeof window.customer !== 'undefined' && window.customer && window.customer.id) {
      customerId = window.customer.id;
    } else if (typeof customer !== 'undefined' && customer && customer.id) {
      customerId = customer.id;
    } else if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
      customerId = window.ShopifyAnalytics.meta.page.customerId;
    } else if (window.Shopify && window.Shopify.customerData && window.Shopify.customerData.customer_id) {
      customerId = window.Shopify.customerData.customer_id;
    }

    if (!customerId) {
      return null;
    }

    // Fetch customer data from Shopify API
    const response = await fetch(`/account/${customerId}.json`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (response.ok) {
      const data = await response.json();
      return data.customer;
    }
  } catch (error) {

  }

  // If API fetch fails, try to return the local customer object if it exists
  if (typeof window.customer !== 'undefined' && window.customer) {
    return window.customer;
  }

  if (typeof customer !== 'undefined' && customer) {
    return customer;
  }

  return null;
}

// The logged-in customer's id, wherever the page exposes it.
function currentCustomerId() {
  if (typeof window.customer !== 'undefined' && window.customer && window.customer.id) return String(window.customer.id);
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) return String(window.ShopifyAnalytics.meta.page.customerId);
  if (window.Shopify && window.Shopify.customerData && window.Shopify.customerData.customer_id) return String(window.Shopify.customerData.customer_id);
  return '';
}

// A pincode a logged-in customer picked during this visit (to check another area): kept for this tab
// only and only for this customer, so the next visit — or another customer on the same device — starts
// from the default address again.
function setSessionPin(pin) {
  try { sessionStorage.setItem('suspire_session_pin', JSON.stringify({ c: currentCustomerId(), pin: String(pin) })); } catch (e) {}
}
function getSessionPin() {
  try {
    const saved = JSON.parse(sessionStorage.getItem('suspire_session_pin') || 'null');
    if (saved && saved.pin && saved.c && saved.c === currentCustomerId()) return saved.pin;
  } catch (e) {}
  return null;
}

// Function to get logged-in user's zip code. Order: a pincode picked during this visit, the default
// address, the first saved address, then (an account with no address) the pincode entered earlier.
function getUserZipCode() {
  if (checkIfLoggedIn()) {
    const sessionPin = getSessionPin();
    if (sessionPin) {
      return sessionPin;
    }
  }

  // Try to get zip code from customer object if available
  if (window.Shopify && window.Shopify.customerData && window.Shopify.customerData.default_address) {
    return window.Shopify.customerData.default_address.zip;
  }

  // Alternative: Try to get from theme's customer object if it's available
  if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.customer && Shopify.theme.customer.default_address) {
    return Shopify.theme.customer.default_address.zip;
  }

  // Try to get from window.customer object (for simulated users)
  if (typeof window.customer !== 'undefined' && window.customer && window.customer.default_address) {
    return window.customer.default_address.zip;
  }

  // Try to get from global customer object
  if (typeof customer !== 'undefined' && customer && customer.default_address) {
    return customer.default_address.zip;
  }

  // Try to get from customer addresses array (window.customer)
  if (typeof window.customer !== 'undefined' && window.customer && window.customer.addresses && window.customer.addresses.length > 0) {
    // Look for default address
    const defaultAddress = window.customer.addresses.find(address => address.id === window.customer.default_address_id);
    if (defaultAddress && defaultAddress.zip) {
      return defaultAddress.zip;
    }
    // If no default address found, use the first address
    if (window.customer.addresses[0] && window.customer.addresses[0].zip) {
      return window.customer.addresses[0].zip;
    }
  }

  // Try to get from customer addresses array (global customer)
  if (typeof customer !== 'undefined' && customer && customer.addresses && customer.addresses.length > 0) {
    // Look for default address
    const defaultAddress = customer.addresses.find(address => address.id === customer.default_address_id);
    if (defaultAddress && defaultAddress.zip) {
      return defaultAddress.zip;
    }
    // If no default address found, use the first address
    if (customer.addresses[0] && customer.addresses[0].zip) {
      return customer.addresses[0].zip;
    }
  }

  // Last resort: check for any address data in localStorage
  const storedAddress = localStorage.getItem('customer_default_address');
  if (storedAddress) {
    try {
      const addressObj = JSON.parse(storedAddress);
      if (addressObj.zip) {
        return addressObj.zip;
      }
    } catch (e) {

    }
  }

  // An account with no address yet: the pincode entered in this browser.
  return getSavedPin() || null;
}

// Function to get saved PIN from localStorage
function getSavedPin() {
  return localStorage.getItem('shopify_pin_code');
}

// Function to save PIN to localStorage
function savePin(pin) {
  localStorage.setItem('shopify_pin_code', pin);
}

// Cache for loaded CSV files to avoid redundant fetches
window.pincodeCSVCache = window.pincodeCSVCache || {};

// Define a named function to reliably block clicks
function blockClickEvent(e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  return false;
}

// Function to disable button with tooltip
function disableButtonWithTooltip(button, message) {
  if (!button) return;

  button.disabled = true;
  button.classList.add('pincode-disabled-btn');
  button.setAttribute('data-pincode-tooltip', message);
  button.style.cursor = 'not-allowed';
  button.style.opacity = '0.6';

  // Prevent any click events (using a named function so we can remove it later)
  button.removeEventListener('click', blockClickEvent, true);
  button.addEventListener('click', blockClickEvent, true);
}

// Function to enable button (remove tooltip and disabled state)
function enableButton(button) {
  if (!button) return;

  button.disabled = false;
  button.classList.remove('pincode-disabled-btn');
  button.removeAttribute('data-pincode-tooltip');
  button.style.cursor = '';
  button.style.opacity = '';
  
  // Restore clickability by removing the blocking listener
  button.removeEventListener('click', blockClickEvent, true);
}

window.pincodeCSVPromises = window.pincodeCSVPromises || {};

// Function to load serviceable pins from CSV with caching
async function loadServiceablePinsFromURL(csvUrl) {
  if (!csvUrl || csvUrl.trim() === '') {
    return [];
  }

  // Check cache first
  if (window.pincodeCSVCache[csvUrl]) {

    return window.pincodeCSVCache[csvUrl];
  }

  if (window.pincodeCSVPromises[csvUrl]) {
    return window.pincodeCSVPromises[csvUrl];
  }

  window.pincodeCSVPromises[csvUrl] = (async () => {
    try {
      const response = await fetch(csvUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const csvText = await response.text();

      const lines = csvText.split('\n');
      const serviceablePins = [];

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line) {
          // Extract the first value (PIN code)
          const pinCode = line.split(',')[0].trim().replace(/['"]/g, '');
          if (pinCode && /^\d+$/.test(pinCode)) {
            serviceablePins.push(pinCode);
          }
        }
      }

      // Cache the result
      window.pincodeCSVCache[csvUrl] = serviceablePins;

      return serviceablePins;
    } catch (error) {

      return [];
    } finally {
      // Clear the promise from cache once it's resolved/rejected
      delete window.pincodeCSVPromises[csvUrl];
    }
  })();

  return window.pincodeCSVPromises[csvUrl];
}

// Function to check if a specific pincode is serviceable for a CSV URL
async function checkPincodeServiceability(pincode, csvUrl) {
  if (!pincode || !csvUrl) {
    return true; // If no pincode or CSV, allow the action
  }

  const serviceablePins = await loadServiceablePinsFromURL(csvUrl);
  return serviceablePins.includes(pincode.toString());
}

// Function to show "Pincode Submitted" notification
function showPincodeSubmittedNotification(pincode, isStandalone = false) {
  if (isStandalone) {
    // If standalone (from header), show immediately and lower down
    window._pendingPincodeNotification = true;
    window._triggerPincodeNotification(true);
    return;
  }

  // Flag that we want to show the pincode toast when the next cart toast appears
  window._pendingPincodeNotification = true;

  // Fallback: If showToast hasn't been called within 3 seconds, something might have failed
  // Show it anyway so the user gets feedback
  setTimeout(() => {
    if (window._pendingPincodeNotification) {
      window._triggerPincodeNotification(false);
    }
  }, 3000);
}

// Global function to actually trigger the notification UI
window._triggerPincodeNotification = function (isStandalone = false) {
  if (!window._pendingPincodeNotification) return;
  window._pendingPincodeNotification = false;

  const cartToast = document.getElementById('Add_to_cart_toast_id');

  // Remove any existing notification
  const existingNotification = document.getElementById('pincode-submitted-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  // Position: Standalone (header) goes at bottom: 20px. Sync (cart) goes at bottom: 80px.
  const bottomPosition = isStandalone ? '20px' : '80px';

  // Create notification element
  const notification = document.createElement('div');
  notification.id = 'pincode-submitted-notification';
  notification.style.cssText = `
    position: fixed;
    bottom: ${bottomPosition}; 
    left: 50%;
    transform: translateX(-50%);
    background-color: #e28b82;
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 99999999;
    font-weight: 400;
    text-align: center;
    box-sizing: border-box;
    white-space: nowrap;
    font-family: inherit;
    letter-spacing: normal;
    line-height: normal;
    display: block !important;
  `;
  notification.textContent = 'Pincode Submitted!';

  // Add unified animation styles for both notifications
  if (!document.getElementById('pincode-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'pincode-notification-styles';
    style.textContent = `
      #pincode-submitted-notification, #Add_to_cart_toast_id {
        animation: notificationSlideUp 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards !important;
        width: 216px !important;
        min-width: 216px !important;
        box-sizing: border-box !important;
        text-align: center !important;
      }
      @keyframes notificationSlideUp {
        from { opacity: 0; transform: translateX(-50%) translateY(30px); }
        to { opacity: 1; transform: translateX(-50%) translateY(0); }
      }
      @keyframes notificationSlideDown {
        from { opacity: 1; transform: translateX(-50%) translateY(0); }
        to { opacity: 0; transform: translateX(-50%) translateY(30px); }
      }
      @media only screen and (max-width: 768px) {
        #pincode-submitted-notification, #Add_to_cart_toast_id {
          left: 50% !important;
          transform: translateX(-50%) !important;
          width: 216px !important;
          min-width: 216px !important;
          white-space: nowrap !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(notification);

  if (isStandalone) {
    // For standalone, use a simple timeout to hide
    setTimeout(() => {
      if (notification && notification.parentNode) {
        notification.style.animation = 'notificationSlideDown 0.3s ease-in forwards';
        setTimeout(() => {
          if (notification.parentNode) notification.parentNode.removeChild(notification);
        }, 300);
      }
    }, 4000);
  } else if (cartToast) {
    // PRECISE EXIT SYNC (for cart-sync mode): Observe the theme's cart toast to hide at the exact same time
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          if (cartToast.style.display === 'none') {
            // Theme hidden the cart toast, so we hide ours too
            notification.style.animation = 'notificationSlideDown 0.3s ease-in forwards';
            setTimeout(() => {
              if (notification.parentNode) notification.parentNode.removeChild(notification);
            }, 300);
            observer.disconnect();
          }
        }
      });
    });
    observer.observe(cartToast, { attributes: true });
  } else {
    // Fallback if no cart toast exists
    setTimeout(() => {
      notification.style.animation = 'notificationSlideDown 0.3s ease-in forwards';
      setTimeout(() => {
        if (notification.parentNode) notification.parentNode.removeChild(notification);
      }, 300);
    }, 3000);
  }
};

// Precise Synchronization: Override the theme's showToast function
// This ensures that WHEN the cart toast happens, our pincode toast happens in the same execution loop
(function () {
  const checkAndHookToast = () => {
    if (typeof window.showToast === 'function' && !window._toastHooked) {
      const originalShowToast = window.showToast;
      window.showToast = function () {
        // Call the original theme toast logic
        originalShowToast.apply(this, arguments);

        // If we have a pending pincode notification, trigger it now
        if (window._pendingPincodeNotification) {
          window._triggerPincodeNotification();
        }
      };
      window._toastHooked = true;

    }
  };

  // Run immediately and also on a few intervals to catch theme.js loading
  checkAndHookToast();
  const hookInterval = setInterval(() => {
    checkAndHookToast();
    if (window._toastHooked) clearInterval(hookInterval);
  }, 500);
  setTimeout(() => clearInterval(hookInterval), 5000);
})();


// Function to validate a single product element
async function validateProductPincode(productElement) {
  const csvUrl = productElement.getAttribute('data-pincode-csv-url');

  // If no CSV URL, this product doesn't have pincode validation
  if (!csvUrl || csvUrl.trim() === '') {
    return;
  }

  // Get user's pincode
  let userPincode = null;

  // Check if user is logged in
  if (checkIfLoggedIn() && window.customer && window.customer.default_address && window.customer.default_address.zip) {
    userPincode = window.customer.default_address.zip;
  } else {
    // Check for saved pincode in localStorage (for guest users)
    userPincode = getSavedPin();
  }

  // If no user pincode, we can't validate yet (will show popup on click)
  if (!userPincode) {
    return;
  }

  // Check if pincode is serviceable
  const isServiceable = await checkPincodeServiceability(userPincode, csvUrl);

  // Find all add-to-cart buttons in this product
  const buttons = productElement.querySelectorAll('[data-add-t-cart-button], .add-to-cart, [name="add"], .btn-cart, .cart-submit, .suspire-buynow-trigger');

  if (!isServiceable) {
    // Disable all buttons with tooltip
    buttons.forEach(button => {
      disableButtonWithTooltip(button, `Not Serviceable for ${userPincode}`);
    });

  } else {
    // Enable buttons
    buttons.forEach(button => {
      enableButton(button);
    });

  }
}

// Function to validate all products on the page
async function validateAllProductsOnPage() {
  const userZipCode = checkIfLoggedIn() ? getUserZipCode() : getSavedPin();
  if (!userZipCode) {

    return;
  }



  // Find all potential add-to-cart buttons
  const allButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], [data-add-t-cart-button], .suspire-buynow-trigger');

  if (allButtons.length === 0) {

    return;
  }

  // Create a map to track and reuse results for the same CSV to avoid redundant validation
  const validationResults = {};

  const validationPromises = Array.from(allButtons).map(async (button) => {
    // Determine the product-specific CSV URL
    let productContainer = button.closest('[data-pincode-csv-url]');
    let csvUrl = productContainer ? productContainer.getAttribute('data-pincode-csv-url') : window.pincodeFileUrl;

    // Fallback: search for CSV via product ID if missing from container
    if (!csvUrl || csvUrl.trim() === '') {
      const productId = button.getAttribute('data-product-id') ||
        (button.closest('[data-product-id]') ? button.closest('[data-product-id]').getAttribute('data-product-id') : null);
      if (productId) {
        const otherProduct = document.querySelector(`[data-pincode-csv-url][data-product-id="${productId}"]`);
        if (otherProduct) {
          csvUrl = otherProduct.getAttribute('data-pincode-csv-url');
        }
      }
    }

    // If no CSV found, we can't validate this button
    if (!csvUrl || csvUrl.trim() === '') {
      return;
    }

    // Use cached result if available for this PIN + CSV combo
    const cacheKey = `${userZipCode}_${csvUrl}`;
    if (validationResults[cacheKey] === undefined) {
      validationResults[cacheKey] = checkPincodeServiceability(userZipCode, csvUrl);
    }

    const isServiceable = await validationResults[cacheKey];

    if (!isServiceable) {
      disableButtonWithTooltip(button, `Not Serviceable for ${userZipCode}`);
    } else {
      enableButton(button);
    }
  });

  await Promise.all(validationPromises);

}

// Function to validate logged-in user's pincode on page load
async function validateUserPincodeOnLoad() {
  try {
    // Get user's zip code
    let userZipCode = getUserZipCode();

    // If we couldn't get the zip code from available sources, try to fetch it from the API
    if (!userZipCode) {
      const customerData = await fetchCustomerData();
      if (customerData && customerData.default_address && customerData.default_address.zip) {
        userZipCode = customerData.default_address.zip;
        // Cache it locally for future use
        localStorage.setItem('customer_default_address', JSON.stringify(customerData.default_address));
      }
    }

    // If we have a zip code, validate it
    if (userZipCode) {

      const isServiceable = await validatePinCode(userZipCode);

      if (!isServiceable) {
        // Show warning message and disable add-to-cart buttons
        showPincodeWarningMessage(userZipCode);
        disableAddToCartButtons();
      } else {
        // Save the valid pincode
        savePin(userZipCode);

      }
    }
  } catch (error) {

  }
}

// Function to show warning message for non-serviceable pincode (persistent banner)
function showPincodeWarningMessage(pincode) {
  // Check if warning already exists
  const existingWarning = document.getElementById('pincode-warning-banner');
  if (existingWarning) {
    return;
  }

  // Create warning banner
  const warningBanner = document.createElement('div');
  warningBanner.id = 'pincode-warning-banner';
  warningBanner.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #e60603;
    color: white;
    padding: 15px 20px;
    text-align: center;
    z-index: 10000;
    font-size: 16px;
    font-weight: 600;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  `;

  warningBanner.innerHTML = `
    ⚠️ Your address PIN code (${pincode}) is not serviceable. Delivery is not available for your location. Please update your address or contact support.
    <button id="dismiss-pincode-warning" style="margin-left: 15px; background: white; color: #e60603; border: none; padding: 5px 15px; border-radius: 4px; cursor: pointer; font-weight: bold;">Dismiss</button>
  `;

  document.body.insertBefore(warningBanner, document.body.firstChild);

  // Add padding to body to prevent content from being hidden
  document.body.style.paddingTop = (warningBanner.offsetHeight) + 'px';

  // Handle dismiss button
  setTimeout(() => {
    const dismissBtn = document.getElementById('dismiss-pincode-warning');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        warningBanner.remove();
        document.body.style.paddingTop = '0';
      });
    }
  }, 100);
}

// Function to disable add-to-cart buttons
function disableAddToCartButtons() {
  const addToCartButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], .suspire-buynow-trigger');
  addToCartButtons.forEach(button => {
    button.disabled = true;
    button.style.opacity = '0.5';
    button.style.cursor = 'not-allowed';
    button.setAttribute('title', 'Delivery not available for your pincode');
  });
}

// Function to show error message for non-serviceable PIN
function showNonServiceablePinMessage() {
  // Remove any existing overlays
  const existingOverlay = document.getElementById('pin-code-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  // Create modal overlay
  const overlay = document.createElement('div');
  overlay.id = 'pin-code-overlay';

  // Create modal content
  const modal = document.createElement('div');
  modal.className = 'pin-modal';

  // Check if user is logged in to customize the message
  const isLoggedIn = checkIfLoggedIn();
  let message = 'Delivery is not available for your location.';

  if (isLoggedIn) {
    message = 'Your address PIN code is not serviceable. Delivery is not available for your location. Please update your address or contact support.';
  } else {
    message = 'The PIN code entered is not serviceable. Delivery is not available for this location.';
  }

  modal.innerHTML = `
    <h3>Service Availability</h3>
    <p>${message}</p>
    <div>
      <button id="close-error-btn">OK</button>
    </div>
    <div id="pin-error-message"></div>
  `;

  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  // Temporarily disable all add-to-cart buttons while the error is displayed
  const addToCartButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], .suspire-buynow-trigger');
  addToCartButtons.forEach(button => {
    button.disabled = true;
    button.setAttribute('data-original-opacity', button.style.opacity || '');
    button.style.opacity = '0.5';
    button.setAttribute('data-original-pointer-events', button.style.pointerEvents || '');
    button.style.pointerEvents = 'none';
  });

  // Handle close button click
  setTimeout(() => {
    const closeBtn = document.getElementById('close-error-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        // Reset the PIN validation pending flag
        window.pinValidationPending = false;
        // Re-enable add-to-cart buttons when closing the modal
        addToCartButtons.forEach(button => {
          button.disabled = false;
          button.style.opacity = button.getAttribute('data-original-opacity') || '';
          button.style.removeProperty('opacity');
          button.style.pointerEvents = button.getAttribute('data-original-pointer-events') || '';
          button.style.removeProperty('pointer-events');
          button.removeAttribute('data-original-opacity');
          button.removeAttribute('data-original-pointer-events');
        });
        document.body.removeChild(overlay);
      });
    }
  }, 100);

  // Close modal when clicking on overlay
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      // Reset the PIN validation pending flag
      window.pinValidationPending = false;
      // Re-enable add-to-cart buttons when closing the modal
      const addToCartButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], .suspire-buynow-trigger');
      addToCartButtons.forEach(button => {
        button.disabled = false;
        button.style.opacity = button.getAttribute('data-original-opacity') || '';
        button.style.removeProperty('opacity');
        button.style.pointerEvents = button.getAttribute('data-original-pointer-events') || '';
        button.style.removeProperty('pointer-events');
        button.removeAttribute('data-original-opacity');
        button.removeAttribute('data-original-pointer-events');
      });
      document.body.removeChild(overlay);
    }
  });
}

// Function to show PIN code popup
function showPinPopup(addToCartButton, productCsvUrl) {
  // Remove any existing overlays
  const existingOverlay = document.getElementById('pin-code-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  // Create modal overlay
  const overlay = document.createElement('div');
  overlay.id = 'pin-code-overlay';

  // Create modal content
  const modal = document.createElement('div');
  modal.className = 'pin-modal';

  modal.innerHTML = `
    <h3>Enter Your PIN Code</h3>
    <p>Please enter your PIN code to check service availability</p>
    <input 
      type="text" 
      id="pin-input" 
      placeholder="Enter PIN code" 
      maxlength="6" 
    >
    <div id="pin-modal-button-group">
      <button id="submit-pin-btn">Submit</button>
      <button id="cancel-pin-btn">Cancel</button>
    </div>
    <div id="pin-error-message"></div>
  `;

  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  // Temporarily disable all add-to-cart buttons while the popup is displayed
  const addToCartButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], .suspire-buynow-trigger');
  addToCartButtons.forEach(button => {
    button.disabled = true;
    button.setAttribute('data-original-opacity', button.style.opacity || '');
    button.style.opacity = '0.5';
    button.setAttribute('data-original-pointer-events', button.style.pointerEvents || '');
    button.style.pointerEvents = 'none';
  });

  // Focus on the input field
  setTimeout(() => {
    const pinInput = document.getElementById('pin-input');
    if (pinInput) {
      pinInput.focus();
    }
  }, 100);

  // Handle submit button click
  setTimeout(() => {
    const submitBtn = document.getElementById('submit-pin-btn');
    const cancelBtn = document.getElementById('cancel-pin-btn');

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        const pinInput = document.getElementById('pin-input');
        const errorMessage = document.getElementById('pin-error-message');
        const pin = pinInput.value.trim();

        // Clear previous error
        errorMessage.textContent = '';

        if (!pin || pin.length !== 6) {
          errorMessage.textContent = 'Please enter a valid 6-digit PIN code';
          return;
        }

        // Disable submit button during validation
        submitBtn.disabled = true;
        submitBtn.textContent = 'Checking...';

        // Validate PIN
        checkPincodeServiceability(pin, productCsvUrl || window.pincodeFileUrl).then(isValid => {


          // Save PIN to localStorage
          savePin(pin);

          // If user is logged in, use this PIN for the rest of the visit (their default address
          // comes back next time), and keep it as the address PIN for an account with no address.
          if (checkIfLoggedIn()) {
            setSessionPin(pin);
            try {
              const existingAddress = localStorage.getItem('customer_default_address');
              if (existingAddress) {
                const addressObj = JSON.parse(existingAddress);
                addressObj.zip = pin;
                localStorage.setItem('customer_default_address', JSON.stringify(addressObj));
              } else {
                const newAddress = { zip: pin };
                localStorage.setItem('customer_default_address', JSON.stringify(newAddress));
              }
            } catch (e) {

            }
          }

          // Reset the PIN validation pending flag
          window.pinValidationPending = false;

          // Close modal and re-enable buttons
          addToCartButtons.forEach(button => {
            button.disabled = false;
            button.style.opacity = button.getAttribute('data-original-opacity') || '';
            button.style.removeProperty('opacity');
            button.style.pointerEvents = button.getAttribute('data-original-pointer-events') || '';
            button.style.removeProperty('pointer-events');
            button.removeAttribute('data-original-opacity');
            button.removeAttribute('data-original-pointer-events');
          });

          document.body.removeChild(overlay);

          // Show "Pincode Submitted" notification
          // Pass !addToCartButton as a flag for standalone mode (header edits)
          showPincodeSubmittedNotification(pin, !addToCartButton);

          // Update header indicator immediately
          if (typeof updateHeaderPincode === 'function') {
            updateHeaderPincode();
          }

          // INSTANT ADD TO CART: Don't wait for the full page validation
          if (isValid) {
            window.pincodeEventReplaying = true;
            if (addToCartButton && typeof addToCartButton.click === 'function') {
              addToCartButton.click();
            } else if (addToCartButton) {
              const form = addToCartButton.closest('form');
              if (form) form.submit();
            }
            setTimeout(() => { window.pincodeEventReplaying = false; }, 1000);
          }

          // Re-validate other products in the background
          validateAllProductsOnPage();
        }).catch(error => {
          errorMessage.textContent = 'Error validating PIN code. Please try again.';

          // Re-enable submit button
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit';
        });
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        // Reset the PIN validation pending flag
        window.pinValidationPending = false;
        // Re-enable add-to-cart buttons when closing the modal
        addToCartButtons.forEach(button => {
          button.disabled = false;
          button.style.opacity = button.getAttribute('data-original-opacity') || '';
          button.style.removeProperty('opacity');
          button.style.pointerEvents = button.getAttribute('data-original-pointer-events') || '';
          button.style.removeProperty('pointer-events');
          button.removeAttribute('data-original-opacity');
          button.removeAttribute('data-original-pointer-events');
        });
        document.body.removeChild(overlay);
      });
    }
  }, 100);

  // Handle Enter key in input
  setTimeout(() => {
    const pinInput = document.getElementById('pin-input');
    if (pinInput) {
      pinInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          const submitBtn = document.getElementById('submit-pin-btn');
          if (submitBtn) {
            submitBtn.click();
          }
        }
      });
    }
  }, 100);

  // Close modal when clicking on overlay
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      // Reset the PIN validation pending flag
      window.pinValidationPending = false;
      // Re-enable add-to-cart buttons when closing the modal
      addToCartButtons.forEach(button => {
        button.disabled = false;
        button.style.opacity = button.getAttribute('data-original-opacity') || '';
        button.style.removeProperty('opacity');
        button.style.pointerEvents = button.getAttribute('data-original-pointer-events') || '';
        button.style.removeProperty('pointer-events');
        button.removeAttribute('data-original-opacity');
        button.removeAttribute('data-original-pointer-events');
      });
      document.body.removeChild(overlay);
    }
  });
}

// Function to validate PIN code against serviceable areas
async function validatePinCode(pin) {
  try {

    // In a real implementation, this would make an API call to check serviceability
    // For now, we'll check against our local serviceable pins list
    const serviceablePins = await loadServiceablePins();


    // Check if pin is in serviceable list
    const isServiceable = serviceablePins.includes(pin.toString());


    // Store validation result in localStorage with timestamp
    if (isServiceable) {
      localStorage.setItem('shopify_pin_validated', 'true');
      localStorage.setItem('shopify_pin_validation_timestamp', Date.now().toString());
    }

    return isServiceable;
  } catch (error) {

    return false;
  }
}

// Function to attach event listeners to add-to-cart buttons
function attachAddToCartListeners() {
  // Intercept form submissions
  const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');

  addToCartForms.forEach(form => {
    // Check if listener is already attached to avoid duplicates
    if (!form.hasAttribute('data-pin-checker-attached')) {
      form.setAttribute('data-pin-checker-attached', 'true');

      // Use capture phase to intercept before other handlers
      form.addEventListener('submit', function (e) {
        handleAddToCartEvent(e, this);
      }, true); // Use capture phase

      // Also add a secondary check to prevent double-submission
      form.addEventListener('submit', function (e) {
        if (window.pinValidationPending) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      }, true); // Capture phase for immediate intervention
    }
  });

  // Also handle direct button clicks as fallback
  const addToCartButtons = document.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart]');

  addToCartButtons.forEach(button => {
    // Don't attach multiple listeners if already attached
    if (!button.hasAttribute('data-pin-checker-listener')) {
      button.setAttribute('data-pin-checker-listener', 'true');

      // Use capture phase to intercept before other handlers
      button.addEventListener('click', function (e) {
        handleAddToCartEvent(e, this);
      }, true); // Use capture phase
    }
  });
}

// Function to handle add to cart events
async function handleAddToCartEvent(e, element) {
  // Check if button is already disabled by pincode validation
  if (element && element.classList && element.classList.contains('pincode-disabled-btn')) {

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  // Get user status and pincode
  const isLoggedIn = checkIfLoggedIn();
  let userZipCode = isLoggedIn ? getUserZipCode() : getSavedPin();

  // 1. GUEST FIRST-CLICK INTERCEPTION (100% GUARANTEE)
  // If guest and no saved pincode, check if CSV exists first
  if (!isLoggedIn && !userZipCode) {


    // Determine CSV URL for the popup to use (if any)
    let productContainer = element.closest('[data-pincode-csv-url]');
    let productCsvUrl = productContainer ? productContainer.getAttribute('data-pincode-csv-url') : window.pincodeFileUrl;

    // Fallback for CSV discovery
    if (!productCsvUrl || productCsvUrl.trim() === '') {
      const productId = element.getAttribute('data-product-id') ||
        (element.closest('[data-product-id]') ? element.closest('[data-product-id]').getAttribute('data-product-id') : null);
      if (productId) {
        const otherProductElement = document.querySelector(`[data-pincode-csv-url][data-product-id="${productId}"]`);
        if (otherProductElement) {
          productCsvUrl = otherProductElement.getAttribute('data-pincode-csv-url');
        }
      }
    }

    // If no CSV file exists for this product/collection, allow add to cart without pincode
    if (!productCsvUrl || productCsvUrl.trim() === '') {

      return; // Allow the event to proceed
    }

    // CSV exists, show pincode popup

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    window.pinValidationPending = true;
    showPinPopup(element, productCsvUrl);
    return false;
  }

  // 2. IDENTIFY CSV URL (for validation of users WITH a pincode)
  let productContainer = element.closest('[data-pincode-csv-url]');
  let productCsvUrl = productContainer ? productContainer.getAttribute('data-pincode-csv-url') : window.pincodeFileUrl;

  // Fallback: If no CSV found, but we have a product ID, look for other elements with that ID
  if (!productCsvUrl || productCsvUrl.trim() === '') {
    const productId = element.getAttribute('data-product-id') ||
      (element.closest('[data-product-id]') ? element.closest('[data-product-id]').getAttribute('data-product-id') : null);
    if (productId) {
      const otherProductElement = document.querySelector(`[data-pincode-csv-url][data-product-id="${productId}"]`);
      if (otherProductElement) {
        productCsvUrl = otherProductElement.getAttribute('data-pincode-csv-url');
      }
    }
  }

  // Double-check if there's a CSV file for this product/collection
  // If no CSV file exists and the user ALREADY has a PIN, allow the event to continue
  if (!productCsvUrl || productCsvUrl.trim() === '') {

    return;
  }

  // If we are replaying this event after validation, let it proceed
  if (window.pincodeEventReplaying) {

    return;
  }

  // Check if PIN validation is already pending
  if (window.pinValidationPending) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }

  // For Logged-in users who still don't have a zip (rare but possible)
  if (isLoggedIn && !userZipCode) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const customerData = await fetchCustomerData();
    if (customerData && customerData.default_address && customerData.default_address.zip) {
      userZipCode = customerData.default_address.zip;
      localStorage.setItem('customer_default_address', JSON.stringify(customerData.default_address));
    } else {
      // If still no zip, treat as guest-like popup flow
      window.pinValidationPending = true;
      showPinPopup(element, productCsvUrl);
      return false;
    }
  }

  // 3. FINAL VALIDATION (User has PIN and Product has CSV)
  if (userZipCode) {
    const isServiceable = await checkPincodeServiceability(userZipCode, productCsvUrl);

    if (isServiceable) {

      savePin(userZipCode);
      return;
    } else {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();


      window.pinValidationPending = true;
      showNonServiceablePinMessage();
      return false;
    }
  }
}

// Function to check if item can be delivered to PIN
function canDeliverToPin(pin) {
  return validatePinCode(pin);
}

// Observe for dynamically added cart buttons
function observeDynamicCartButtons() {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is a cart form
          if (node.tagName === 'FORM' && node.getAttribute('action') && node.getAttribute('action').indexOf('/cart/add') !== -1) {
            // Check if listener is already attached to avoid duplicates
            if (!node.hasAttribute('data-pin-checker-attached')) {
              node.setAttribute('data-pin-checker-attached', 'true');
              // Use capture phase to intercept before other handlers
              node.addEventListener('submit', function (e) {
                handleAddToCartEvent(e, this);
              }, true);
            }
          }

          // Check if it contains cart buttons
          const cartButtons = node.querySelectorAll ? Array.from(node.querySelectorAll('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart]')) : [];

          // Also check if the node itself is a cart button
          if (node.matches && node.matches('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart]')) {
            cartButtons.push(node);
          }

          cartButtons.forEach(button => {
            if (!button.hasAttribute('data-pin-checker-listener')) {
              button.setAttribute('data-pin-checker-listener', 'true');
              // Use capture phase to intercept before other handlers
              button.addEventListener('click', function (e) {
                handleAddToCartEvent(e, this);
              }, true);
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Expose functions globally for theme integration if needed
window.PinCodeChecker = {
  checkIfLoggedIn,
  getSavedPin,
  savePin,
  validatePinCode,
  canDeliverToPin
};

// Additional protection: Watch for cart additions via JavaScript events
setTimeout(() => {
  // Monitor for any cart add events that might bypass our validation
  document.addEventListener('click', function (e) {
    // Check if the click is on an add to cart button or form
    const isAddToCartElement = e.target.closest('[name="add"], .add-to-cart, .btn-cart, .cart-submit, [data-add-to-cart], form[action*="/cart/add"]');

    if (isAddToCartElement && window.pinValidationPending) {
      // Prevent the action if validation is pending
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      return false;
    }
  }, true);

  // Even more comprehensive cart request blocking
  // Additional safeguard: Monitor for cart API calls
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0];

    // Block cart add requests if validation is pending
    if (window.pinValidationPending && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {

      return Promise.resolve({
        ok: false,
        status: 400,
        json: () => Promise.resolve({ error: 'Cart operation blocked due to PIN validation' }),
        text: () => Promise.resolve('Cart operation blocked due to PIN validation')
      });
    }

    // Also check for general cart operations when validation is pending
    if (window.pinValidationPending && typeof url === 'string' && url.includes('/cart')) {

    }

    return originalFetch.apply(this, args);
  };

  // If jQuery is available, intercept jQuery AJAX calls for cart operations
  if (typeof jQuery !== 'undefined' && jQuery.ajax) {
    const originalAjax = jQuery.ajax;
    jQuery.ajax = function (options) {
      // Check if this is a cart add request
      const url = typeof options === 'string' ? options : (options.url || '');

      if (window.pinValidationPending && typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {

        // Return a rejected promise to prevent the request
        return Promise.reject({
          status: 400,
          responseText: 'Cart operation blocked due to PIN validation',
          responseJSON: { error: 'Cart operation blocked due to PIN validation' }
        });
      }

      // Also check for general cart operations when validation is pending
      if (window.pinValidationPending && typeof url === 'string' && url.includes('/cart')) {

      }

      // Otherwise, proceed with the original ajax call
      return originalAjax.apply(this, arguments);
    };
  }
}, 1000); // Delay slightly to ensure initialization